import Swiper, { Navigation, Autoplay, FreeMode, Grid } from 'swiper';
if (customElements.get('component-cards') === undefined) {
    class Cards extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.prev = document.querySelector('#slider-prev');
            this.next = document.querySelector('#slider-next');
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Navigation, Autoplay, Grid],
                slidesPerView: 3,
                spaceBetween: 32,
                speed: 700,
                //loop: true,
                //freeMode: true,
                //freeModeMomentum: true,
                autoplay: {
                    delay: 5000,
                },
                grid: {
                    rows: 2,
                },
                navigation: {
                    nextEl: this.next,
                    prevEl: this.prev,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        grid: {
                            rows: 3,
                        },
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        grid: {
                            rows: 2,
                        },
                    },
                    1024: {
                        spaceBetween: 40,
                        freeMode: false
                    },
                },
            });
        }
    }
    customElements.define('component-cards', Cards);
}
